import { Route, Switch } from 'react-router-dom';
import ErrorPage from 'components/ErrorPage';
import ConfigPage from 'pages/ConfigPage';
import ThemeCustomizationPage from 'pages/ThemeCustomizationPage';
import {
  ROUTE_FRAME_CONFIG,
  ROUTE_FRAME_BRAND_CUSTOMIZATION,
  ROUTE_FRAME_THEMES,
} from '../../utils/routes';
import ThemeLibraryPage from 'pages/ThemeLibraryPage';
import { useTranslation } from 'react-i18next';

const RenderError404 = () => {
  const { t } = useTranslation();
  return <ErrorPage headerText={t('NotFound')} bodyText={t('ErrorMessage')} hideContainerClass />;
};

export const WebFrameContent = () => {
  return (
    <div className="ui container module-container frame">
      <Switch>
        <Route path={ROUTE_FRAME_CONFIG} component={ConfigPage} exact />
        <Route path={ROUTE_FRAME_BRAND_CUSTOMIZATION} component={ThemeCustomizationPage} exact />
        <Route path={ROUTE_FRAME_THEMES} component={ThemeLibraryPage} exact />
        <Route component={RenderError404} />
      </Switch>
    </div>
  );
};
